import { t } from 'i18next'
import { z } from 'zod'

import { hasHttpProtocol } from 'features/yieldbirdWrapperAgent/utils/url'

export const MAX_URLS: number = 10

const SAFE_MAX_URL_LENGTH: number = 2_048

const DEFAULT_PROTOCOL: string = 'https://'

const isValidUrl = (value: string): boolean =>
  z.httpUrl().safeParse(hasHttpProtocol(value) ? value : `${DEFAULT_PROTOCOL}${value}`).success

const urlSchema = z
  .string()
  .trim()
  .min(1)
  .max(SAFE_MAX_URL_LENGTH)
  .refine(isValidUrl, {
    error: () => t('features/yieldbirdWrapperAgent:form.urls.error.invalid'),
  })

export const schema = z.object({
  urls: z
    .array(urlSchema)
    .min(1)
    .max(MAX_URLS, {
      error: () => t('features/yieldbirdWrapperAgent:form.urls.error.max', { count: MAX_URLS }),
    }),
})

export type Schema = z.infer<typeof schema>

export const schemaDefaults: Schema = {
  urls: [],
}
